import React from 'react';
import {
  TrendingUp, Search, Handshake, Plane,
  Building, Scale, Calculator, Truck,
  Landmark, Calendar, Megaphone, Users
} from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

const ServicesSection = () => {
  const { t } = useLanguage();

  const categoryIcons = [
    [Search, Handshake, Plane, TrendingUp],
    [Building, Scale, Calculator, Truck],
    [Landmark, Calendar, Megaphone, Users]
  ];

  const categories = t('services.categories');

  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-24 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-12 h-[2px] bg-[#C9A84C]" />
            <span className="text-[#C9A84C] font-semibold text-sm tracking-wider uppercase">
              Portfolio
            </span>
            <div className="w-12 h-[2px] bg-[#C9A84C]" />
          </div>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-[#1A1F4B] mb-4">
            {t('services.title')}
          </h2>
          <p className="text-[#1F2937]/70 max-w-2xl mx-auto">
            {t('services.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {categories.map((category, catIndex) => (
            <div
              key={catIndex}
              className={`p-8 ${catIndex === 1 ? 'bg-[#1A1F4B] text-white' : 'bg-[#F9FAFB]'}`}
              data-testid={`service-category-${catIndex}`}
            >
              <h3 className={`font-heading text-xl font-bold mb-6 ${
                catIndex === 1 ? 'text-white' : 'text-[#1A1F4B]'
              }`}>
                {category.title}
              </h3>

              <div className="space-y-4">
                {category.items.map((item, itemIndex) => {
                  const Icon = categoryIcons[catIndex][itemIndex];
                  return (
                    <div
                      key={itemIndex}
                      className="flex items-center gap-3"
                      data-testid={`service-item-${catIndex}-${itemIndex}`}
                    >
                      <div className={`w-10 h-10 flex items-center justify-center ${
                        catIndex === 1 ? 'bg-[#C9A84C]/20' : 'bg-[#1A1F4B]'
                      }`}>
                        <Icon className={`w-5 h-5 ${
                          catIndex === 1 ? 'text-[#C9A84C]' : 'text-white'
                        }`} />
                      </div>
                      <span className={`text-sm font-medium ${
                        catIndex === 1 ? 'text-white/90' : 'text-[#1F2937]'
                      }`}>
                        {item}
                      </span>
                    </div>
                  );
                })}
              </div>

              <div className={`mt-8 h-1 w-16 ${
                catIndex === 1 ? 'bg-[#C9A84C]' : 'bg-[#1A1F4B]'
              }`} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
